module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"welcome":"Goal","pick":"Pick Deployment","location":"Select Location","deploy":"Deploy"}}')
  delete Component.options._Ctor
}
